import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isFcmEnabled, registerWebPushToken } from '../services/firebase';
import { registerFcmDevice } from '../redux/actions/chatRealtime';

export const useFcmRegistration = (user) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!user || !isFcmEnabled()) return;

        const setup = async () => {
            try {
                const token = await registerWebPushToken();
                if (token) {
                    await dispatch(registerFcmDevice(token, 'web'));
                }
            } catch (err) {
                console.warn('[FCM] Registro de dispositivo falló:', err.message);
            }
        };

        setup();
    }, [user, dispatch]);
};
